import * as React from "react";
import posed from "react-pose";
import styled, { css } from "../../../../libs/components/styled/index";
import { CS } from "../../../../libs/components/styles/index";
import { Box } from "../../../../libs/components/libs/box/index";

const MainPose = posed.div({
  visible: {
    opacity: 1,
    translateY: 0,
  },
  hidden: {
    opacity: 0,
    translateY: 14,
  },
});

const Main = styled(MainPose)`
  ${CS.flex.center};
  padding: 20px;
  min-height: 90vh;
`;

const Content = styled("div")`
  width: 360px;
  margin: 0 auto;
`;

const Logo = styled("div")`
  text-align: center;
  margin-bottom: 30px;
  img {
    max-height: 60px;
  }
`;

const ContentBox = styled(Box)`
  border-radius: 3px;
  box-shadow: 0 4px 36px rgba(0, 0, 0, 0.2);
  .box-loader {
    border-radius: 3px;
  }
`;

export const AuthLayoutComponents = {
  Main, Content, Logo, ContentBox,
};
